import {
  CheckOutlined,
  ClockCircleOutlined,
  ReloadOutlined,
} from '@ant-design/icons';

export const taskStatusIcon = (value?: string, fontSize: number = 24) => {
  if (value === 'NotProcessed') {
    return <ClockCircleOutlined style={{ color: '#8C8C8C', fontSize }} />;
  }
  if (value === 'InProcessing') {
    return <ReloadOutlined style={{ color: '#49A4D8', fontSize }} />;
  }
  return <CheckOutlined style={{ color: '#6FC067', fontSize }} />;
};
